function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.026,36.861c-0.474,0-0.955-0.112-1.403-0.35c-1.464-0.776-2.021-2.592-1.245-4.056 c4.113-7.755,10.383-14.032,18.133-18.154c1.463-0.777,3.28-0.223,4.057,1.24c0.778,1.463,0.223,3.279-1.24,4.057 c-6.688,3.558-12.1,8.976-15.649,15.668C19.14,36.282,18.101,36.861,17.026,36.861"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M33.894,91.836c-0.476,0-0.959-0.113-1.408-0.353c-7.702-4.104-13.944-10.342-18.054-18.039 c-0.78-1.463-0.227-3.279,1.234-4.06c1.462-0.78,3.279-0.228,4.06,1.234c3.546,6.644,8.934,12.028,15.581,15.569 c1.462,0.778,2.016,2.596,1.237,4.058C36.005,91.259,34.967,91.836,33.894,91.836"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M72.078,91.852c-1.074,0-2.112-0.578-2.651-1.592c-0.778-1.463-0.224-3.28,1.239-4.058 c6.652-3.537,12.047-8.919,15.598-15.563c0.782-1.462,2.6-2.012,4.061-1.231s2.013,2.599,1.231,4.06 C87.441,81.167,81.191,87.402,73.484,91.5C73.035,91.739,72.552,91.852,72.078,91.852"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M88.952,36.819c-1.074,0-2.112-0.578-2.651-1.592c-3.564-6.703-8.996-12.121-15.708-15.67 c-1.465-0.775-2.024-2.59-1.25-4.054c0.775-1.465,2.591-2.025,4.056-1.25c7.775,4.111,14.068,10.39,18.199,18.157 c0.778,1.463,0.223,3.279-1.24,4.057C89.909,36.706,89.426,36.819,88.952,36.819"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M53,27.543c-7.594,0-13.772-6.178-13.772-13.772C39.229,6.178,45.406,0,53,0 c7.594,0,13.772,6.178,13.772,13.771C66.773,21.365,60.594,27.543,53,27.543 M53,6c-4.285,0-7.772,3.486-7.772,7.771 c0,4.286,3.487,7.772,7.772,7.772c4.284,0,7.772-3.486,7.772-7.772C60.773,9.486,57.285,6,53,6"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M53,106c-7.594,0-13.772-6.178-13.772-13.771S45.406,78.457,53,78.457c7.594,0,13.772,6.178,13.772,13.771 S60.594,106,53,106 M53,84.457c-4.285,0-7.772,3.486-7.772,7.771S48.715,100,53,100c4.284,0,7.772-3.486,7.772-7.771 S57.285,84.457,53,84.457"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.772,66.771C6.178,66.771,0,60.594,0,53c0-7.594,6.178-13.771,13.772-13.771 c7.594,0,13.772,6.178,13.772,13.771C27.544,60.594,21.366,66.771,13.772,66.771 M13.772,45.228C9.487,45.228,6,48.714,6,53 s3.487,7.771,7.772,7.771c4.285,0,7.772-3.486,7.772-7.771S18.057,45.228,13.772,45.228"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M92.228,66.771c-7.594,0-13.771-6.177-13.771-13.771c0-7.594,6.178-13.771,13.771-13.771 C99.823,39.228,106,45.406,106,53C106,60.594,99.823,66.771,92.228,66.771 M92.228,45.228c-4.284,0-7.771,3.486-7.771,7.771 s3.487,7.771,7.771,7.771c4.285,0,7.772-3.486,7.772-7.771S96.513,45.228,92.228,45.228"
});

var SvgGruppi = function SvgGruppi(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "-0.067 -0.363 107 107",
    enableBackground: "new -0.067 -0.363 107 107",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGruppi, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gruppi.128966c6.svg";
export { ForwardRef as ReactComponent };